var map = {
	"./1.ogg": "./src/EGRContent/Story/PerfectCircle/audios/1.ogg",
	"./12.ogg": "./src/EGRContent/Story/PerfectCircle/audios/12.ogg",
	"./13.ogg": "./src/EGRContent/Story/PerfectCircle/audios/13.ogg",
	"./15a.ogg": "./src/EGRContent/Story/PerfectCircle/audios/15a.ogg",
	"./15c.ogg": "./src/EGRContent/Story/PerfectCircle/audios/15c.ogg",
	"./5.ogg": "./src/EGRContent/Story/PerfectCircle/audios/5.ogg",
	"./bensad-min.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bensad-min.ogg",
	"./bg/drawing.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/drawing.ogg",
	"./bg/insert.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/insert.ogg",
	"./bg/se_page10.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/se_page10.ogg",
	"./bg/se_page11.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/se_page11.ogg",
	"./bg/se_page12.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/se_page12.ogg",
	"./bg/se_page2to4.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/se_page2to4.ogg",
	"./bg/se_page5.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/se_page5.ogg",
	"./bg/se_page6.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/se_page6.ogg",
	"./bg/se_page7.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/se_page7.ogg",
	"./bg/se_page8.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/se_page8.ogg",
	"./bg/se_page9.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg/se_page9.ogg",
	"./bg1.ogg": "./src/EGRContent/Story/PerfectCircle/audios/bg1.ogg",
	"./blank.ogg": "./src/EGRContent/Story/PerfectCircle/audios/blank.ogg",
	"./circle.ogg": "./src/EGRContent/Story/PerfectCircle/audios/circle.ogg",
	"./happyMusic.ogg": "./src/EGRContent/Story/PerfectCircle/audios/happyMusic.ogg",
	"./justKidding-2.ogg": "./src/EGRContent/Story/PerfectCircle/audios/justKidding-2.ogg",
	"./justKidding.ogg": "./src/EGRContent/Story/PerfectCircle/audios/justKidding.ogg",
	"./kinaNakhayeko zeya k vayo bhanata .ogg": "./src/EGRContent/Story/PerfectCircle/audios/kinaNakhayeko zeya k vayo bhanata .ogg",
	"./kinaNakhayekoKhaiHalataNani.ogg": "./src/EGRContent/Story/PerfectCircle/audios/kinaNakhayekoKhaiHalataNani.ogg",
	"./perfect-circle-annoyed.ogg": "./src/EGRContent/Story/PerfectCircle/audios/perfect-circle-annoyed.ogg",
	"./perfect-circle-cry.ogg": "./src/EGRContent/Story/PerfectCircle/audios/perfect-circle-cry.ogg",
	"./perfect.ogg": "./src/EGRContent/Story/PerfectCircle/audios/perfect.ogg",
	"./playground-min.ogg": "./src/EGRContent/Story/PerfectCircle/audios/playground-min.ogg",
	"./playground.ogg": "./src/EGRContent/Story/PerfectCircle/audios/playground.ogg",
	"./rectangle.ogg": "./src/EGRContent/Story/PerfectCircle/audios/rectangle.ogg",
	"./square.ogg": "./src/EGRContent/Story/PerfectCircle/audios/square.ogg",
	"./triangle.ogg": "./src/EGRContent/Story/PerfectCircle/audios/triangle.ogg",
	"./zeya_first_word.ogg": "./src/EGRContent/Story/PerfectCircle/audios/zeya_first_word.ogg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/PerfectCircle/audios sync recursive ^\\.\\/.*$";